<template>
  <!--精品推荐 -->
  <el-container class="modelrecommend">
    <!-- <el-header :height="'70'">
      <home-header :opacity="opacity"></home-header>
    </el-header>-->
    <el-main class="recommandmain">
      <div style="margin:10px auto;width:1200px">
        <search-andselect></search-andselect>
      </div>
      <div class="recommend">
        <div class="recommend-left">
          <img :src="bigimg.photo1" @click="IntoGroup" />
          <div class="bigimgtitle">{{bigimg.title}}</div>
        </div>
        <div class="recommend-right">
          <div class="recommend-right-one">
            <column-two :top="themestop" :bottom="themesbot"></column-two>
          </div>
          <div class="recommend-right-one">
            <column-two :top="themestop1" :bottom="themesbot1"></column-two>
          </div>
        </div>
      </div>
      <!-- 精品推荐 -->
      <div class="activity">
        <hot-topic :hot="hot"></hot-topic>
      </div>
    </el-main>
    <el-footer v-if="hidefooter" style="height:316px">
      <home-footer></home-footer>
    </el-footer>
  </el-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import homeFooter from "../components/homeFooter.vue"; //底部
import homeHeader from "../components/homeHeader.vue"; //头部
import homeHeaderAd from "../components/homeHeaderAd.vue"; //头部
import homeFooterAd from "../components/homeFooterAd.vue"; //底部
import searchAndselect from "../components/searchAndselect"; //搜索框
import adSearch from "../components/adSearch.vue";
import titles from "../components/titles.vue"; //全部分类
import columnTwo from "../components/columnTwo.vue"; //上下两个图片
import {
  getModuleInfo,
  getResource,
  getCategoryNode
} from "./../services/api.js";
import imgCard from "../components/imgCard.vue";
import hotTopic from "../components/hotTopic.vue"; //热门专题
export default {
  data() {
    return {
      bigimg: "",
      moduleIds: [1],
      titlelist: [],
      carousels: [],
      themestop: {},
      themesbot: {},
      themestop1: {},
      themesbot1: {},
      hot: {
        id: "",
        list: []
      },
      opacity: "0.68"
    };
  },
  components: {
    homeFooter,
    homeHeader,
    homeHeaderAd, //广告头
    homeFooterAd, //广告底
    adSearch, //带有广告位search
    titles, //全部分类
    columnTwo, //上下两个图片
    imgCard,
    hotTopic, //热门专题
    searchAndselect
  },
  mounted() {
    this.getThems();
    this.getThemsB();
    this.getThemsC();
    // window.addEventListener("scroll", this.mosewheel, true);
  },
  watch: {
    channel_id() {
      this.getThems();
      this.getThemsB();
      this.getThemsC();
    }
  },
  computed: {
    ...mapGetters([
      "webModels",
      "curModelInfo",
      "modelsInfo",
      "webID",
      "hidefooter"
    ]),
    channel_id() {
      return this.curModelInfo.id;
      // return this.modelsInfo.filter(item => item.tpl_id == 8)[0].id;
    }
  },
  methods: {
    IntoGroup() {
      console.log(this.bigimg);
      this.$router.push({
        path: "/searchSingle",
        query: {
          isEnglish: false,
          type: 0,
          text: "",
          group_id: this.bigimg.group_id
        }
      });
    },
    async getHotsDataByCategoryChangeV(item, size) {
      var obj = {
        review_state: 1 + "",
        search_type: 2 + "",
        // online_state: 1 + "",
        customer_id: this.webid,
        group_id: item.body9
      };
      if (item.body10 == "1") {
        let resul = await getResource(obj, 2);
        return {
          photo1: resul.data
            ? this.getSpecialShowImgUrl(resul.data.data[0], size)
            : "",
          link_url: `/search?isEnglish=false&type=1&text=&group_id=${item.body9}`,
          title: resul.data ? resul.data.data[0].group_title : ""
        };
      } else if (item.body10 == "2") {
        let resul = await getCategoryNode({
          customer_id: this.webid,
          category_id: item.body9
        });
        return {
          photo1: resul.data
            ? this.getSpecialShowImgUrl_Category(resul.data[0], size)
            : "",
          link_url: `/intopic?category=${item.body9}&text=${
            resul.data ? resul.data[0].cname : ""
          }&bigimg=${resul.data ? resul.data[0].index_image : ""}`,
          title: resul.data ? resul.data[0].cname : ""
        };
      } else if (item.body10 == "3") {
        return {
          photo1: item.promotion_cover,
          link_url: `/#/spread?promotion=${item.promotion_pic}`,
          title: "推广页"
        };
      }
    },
    getSpecialShowImgUrl_Category(item, size) {
      if (item.custom_index_image) {
        if (item.custom_index_image[size]) {
          return item.custom_index_image[size];
        }
      }
      return item.index_image;
    },
    getSpecialShowImgUrl(item, size) {
      if (item.group_custom_index_image) {
        if (item.group_custom_index_image[size]) {
          return item.group_custom_index_image[size];
        }
      }
      return item.group_index_image;
    },

    mosewheel(event) {
      let scrolltop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
      if (scrolltop == 0) {
        this.opacity = "0.68";
      } else {
        this.opacity = "1";
      }
    },

    getThemsC() {
      let data = {
        module_id: 21,
        web_id: this.webID,
        use_sort_num: 1,
        channel_id: this.channel_id //频道id
      };
      getModuleInfo(data).then(async res => {
        if (res.status_code == 1) {
          this.themestop = res.data.list.shift();
          let themestopresul = await this.getHotsDataByCategoryChangeV(
            this.themestop,
            "1200x800"
          );
          this.themestop.photo1 = themestopresul.photo1;
          this.themestop.link_url = themestopresul.link_url;
          this.themestop.title = themestopresul.title;

          this.themesbot = res.data.list.shift();
          let themesbotresul = await this.getHotsDataByCategoryChangeV(
            this.themesbot,
            "1200x800"
          );
          this.themesbot.photo1 = themesbotresul.photo1;
          this.themesbot.link_url = themesbotresul.link_url;
          this.themesbot.title = themesbotresul.title;

          this.themestop1 = res.data.list.shift();
          let themestop1resul = await this.getHotsDataByCategoryChangeV(
            this.themestop1,
            "1200x800"
          );
          this.themestop1.photo1 = themestop1resul.photo1;
          this.themestop1.link_url = themestop1resul.link_url;
          this.themestop1.title = themestop1resul.title;

          this.themesbot1 = res.data.list.shift();
          let themesbot1resul = await this.getHotsDataByCategoryChangeV(
            this.themesbot1,
            "1200x800"
          );
          this.themesbot1.photo1 = themesbot1resul.photo1;
          this.themesbot1.link_url = themesbot1resul.link_url;
          this.themesbot1.title = themesbot1resul.title;
        }
      });
    },
    getThemsB() {
      let data = {
        module_id: 20,
        web_id: this.webID,
        use_sort_num: 1,
        channel_id: this.channel_id //频道id
      };
      getModuleInfo(data).then(async res => {
        if (res.status_code == 1) {
          this.bigimg = res.data.list.shift();

          let bigimgresul = await this.getHotsDataByCategoryChangeV(
            this.bigimg,
            "900x1000"
          );
          this.bigimg.photo1 = bigimgresul.photo1;
          this.bigimg.link_url = bigimgresul.link_url;
          this.bigimg.title = bigimgresul.title;
        }
      });
    },
    getThems() {
      let data = {
        module_id: 19,
        web_id: this.webID,
        use_sort_num: 1,
        channel_id: this.channel_id //频道id
      };
      getModuleInfo(data).then(async res => {
        if (res.status_code == 1) {
          this.hot = {
            id: this.hot.id,
            list: res.data.list
          };
          for (let i = 0; i < this.hot.list.length; i++) {
            let resul = await this.getHotsDataByCategoryChangeV(
              this.hot.list[i],
              "800x500"
            );
            this.hot.list[i].photo1 = resul.photo1;
            this.hot.list[i].link_url = resul.link_url;
            this.hot.list[i].title = resul.title;
            this.$set(this.hot.list, i, this.hot.list[i]);
          }
        }
      });
    }
  }
};
</script>
<style lang="less">
.modelrecommend {
  // min-height: 100%;
  .recommandmain {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0px;
    .recommend {
      width: 1200px;
      margin: 0px auto;
      height: 500px;
      position: relative;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      .recommend-left {
        width: 450px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .bigimgtitle {
          position: absolute;
          left: 0px;
          bottom: 0px;
          width: 100%;
          height: 42px;
          background-color: rgba(0, 0, 0, 0.5);
          color: white;
          box-sizing: border-box;
          line-height: 42px;
          padding-left: 15px;
        }
      }
      .recommend-right {
        width: 740px;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        .recommend-right-one {
          width: 365px;
        }
      }
    }
    .activity {
      padding: 0px 0px;
      width: 1200px;
      margin: 30px auto;
    }
  }
  .el-footer {
    padding: 0px;
  }
}
</style>






// WEBPACK FOOTER //
// src/page/recommend.vue